const lightbox = {
    bind(dialog, items) {
        const full = dialog.querySelector(".lb-full");
        const container = dialog.querySelector(".lb-main");
        const zoom_hint = dialog.querySelector(".lb-zoom-hint");
        // prevent native image drag
        full.draggable = false;
        full.ondragstart = (e) => e.preventDefault();
        let is_down = false;
        let start_x = 0;
        let start_y = 0;
        let offset_x = 0;
        let offset_y = 0;
        let origin_x = 0;
        let origin_y = 0;
        let base_scale = 1;
        let scale = base_scale;
        let min_scale = Math.min(0.25, base_scale);
        const max_scale = 4;
        const apply_transform = () => {
            full.style.transform =
                `translate(calc(-50% + ${offset_x}px), calc(-50% + ${offset_y}px)) scale(${scale})`;
        };
        container.addEventListener("wheel", (e) => {
            e.preventDefault();
            hide_hint();
            scale += (e.deltaY < 0 ? 1 : -1) * (min_scale / 2);
            scale = Math.max(min_scale, Math.min(max_scale, scale));
            apply_transform();
        });
        container.addEventListener("mouseleave", () => {
            if (!is_down) return;
            is_down = false;
            container.classList.remove("dragging");
            full.classList.remove("dragging");
        });
        full.onload = () => {
            const container_w = container.clientWidth;
            const container_h = container.clientHeight;
            const image_w = full.naturalWidth;
            const image_h = full.naturalHeight;
            const fit_scale = Math.min(
                container_w / image_w,
                container_h / image_h
            );
            base_scale = fit_scale;
            min_scale = fit_scale / 2;
            scale = base_scale * .9;
            offset_x = 0;
            offset_y = 0;
            apply_transform();
            full.style.display = "block";
        };
        const hide_hint = () => {
            if (!zoom_hint) return;
            zoom_hint.style.opacity = "0";
            setTimeout(() => {
                zoom_hint.remove();
            }, 250);
        };
        const onMove = (e) => {
            if (!is_down) return;
            const dx = e.clientX - start_x;
            const dy = e.clientY - start_y;
            offset_x = origin_x + dx;
            offset_y = origin_y + dy;
            apply_transform();
        };
        const onUp = (e) => {
            if (!is_down) return;
            is_down = false;
            container.classList.remove("dragging");
            full.classList.remove("dragging");
        };
        const onLeave = () => {
            is_down = false;
            container.classList.remove("dragging");
            full.classList.remove("dragging");
        };
        dialog.addEventListener("mousemove", onMove);
        dialog.addEventListener("mouseup", onUp);
        dialog.addEventListener("mouseleave", onLeave);
        container.addEventListener("mousedown", (e) => {
            e.preventDefault();
            hide_hint();
            is_down = true;
            container.classList.add("dragging");
            full.classList.add("dragging");
            start_x = e.clientX;
            start_y = e.clientY;
            origin_x = offset_x;
            origin_y = offset_y;
        });
        dialog.querySelectorAll(".dialog-close ").forEach(closer => {
            closer.onclick = () => {
                cleanup();
                dialog.close();
                dialog.remove();
            };
        });
        dialog.addEventListener("click", (e) => {
            if (e.target === dialog) {
                cleanup();
                dialog.close();
                dialog.remove();
            }
        });
        dialog.querySelectorAll(".lb-thumb").forEach(thumb => {
            thumb.onclick = () => {
                document.querySelectorAll(".lb-full").forEach(full => full.style.display = "none");
                const i = +thumb.dataset.index;
                full.src = items[i].full;
                offset_x = 0;
                offset_y = 0;
                scale = base_scale;
                apply_transform();
                dialog.querySelectorAll(".lb-thumb")
                    .forEach(t => t.classList.remove("active"));
                thumb.classList.add("active");
            };
        });
        const cleanup = () => {
            dialog.removeEventListener("mousemove", onMove);
            dialog.removeEventListener("mouseup", onUp);
            dialog.removeEventListener("mouseleave", onLeave);
            document.body.style.overflow = "";
        };
        dialog.addEventListener("close", () => {
            cleanup();
            dialog.remove();
        });
    },
    build(items, activeIndex) {
        const dialog = document.createElement("dialog");
        dialog.className = "lb-dialog";
        dialog.innerHTML = `
            <div class="lb-wrap">
                <div class="dialog-close lb-esc-hint">Esc</div>
                <button class="dialog-close lb-close" aria-label="Close"></button>
                <div class="lb-main">
                    <img class="lb-full" src="${items[activeIndex].full}">
                </div>
                <div class="lb-zoom-hint">Scroll to zoom</div>
                <div class="lb-thumbs">
                    ${items.map((item, i) => `
                        <img
                            src="${item.thumb}"
                            data-index="${i}"
                            class="lb-thumb ${i === activeIndex ? "active" : ""}"
                        >
                    `).join("")}
                </div>
            </div>
        `;
        this.bind(dialog, items);
        return dialog;
    },
    init(selector = ".zoomable") {
        const els = document.querySelectorAll(selector);
        els.forEach(el => {
            el.addEventListener("click", () => {
                this.open(el);
            });
        });
    },
    open(clicked) {
        if (global.isTouch) return;
        const images = [...document.querySelectorAll("[data-full]")];
        const items = images.map(img => ({
            thumb: img.dataset.thumb,
            full: img.dataset.full
        }));
        const index = images.indexOf(clicked);
        const dialog = this.build(items, index);
        document.body.appendChild(dialog);
        dialog.showModal();
        dialog.querySelector(".lb-close")?.blur();
        document.body.style.overflow = "hidden";
    },
};
$(() => {
    lightbox.init();
});